import * as React from "react";
import { useCallback, useMemo } from "react";
import UserDateTimeContext from "contexts/UserDateTimeContext";
import AppConfig from "util/AppConfig";
import useCurrentUser from "hooks/useCurrentUser";
import { DATE_TIME_FORMATS, getBrowserTimezone, toDateObject } from "util/DateTime";
const getUserTimezone = (userTimezone, tzOverride) => {
  var _a, _b;
  if (tzOverride) {
    return tzOverride;
  }
  return (_b = (_a = userTimezone != null ? userTimezone : getBrowserTimezone()) != null ? _a : AppConfig.rootTimeZone()) != null ? _b : "UTC";
};
const StaticTimezoneProvider = ({ children, tz }) => {
  const toUserTimezone = useCallback((time) => toDateObject(time, void 0, tz), [tz]);
  const formatTime = useCallback(
    (time, format = "default") => toUserTimezone(time).format(DATE_TIME_FORMATS[format]),
    [toUserTimezone]
  );
  const contextValue = useMemo(
    () => ({ toUserTimezone, formatTime, userTimezone: tz }),
    [toUserTimezone, formatTime, tz]
  );
  return /* @__PURE__ */ React.createElement(UserDateTimeContext.Provider, { value: contextValue }, children);
};
const CurrentUserDateTimeProvider = ({ children }) => {
  const currentUser = useCurrentUser();
  const userTimezone = useMemo(() => getUserTimezone(currentUser == null ? void 0 : currentUser.timezone), [currentUser == null ? void 0 : currentUser.timezone]);
  return /* @__PURE__ */ React.createElement(StaticTimezoneProvider, { tz: userTimezone }, children);
};
const UserDateTimeProvider = ({ children, tz: tzOverride = void 0 }) => tzOverride ? /* @__PURE__ */ React.createElement(StaticTimezoneProvider, { tz: tzOverride }, children) : /* @__PURE__ */ React.createElement(CurrentUserDateTimeProvider, null, children);
export default UserDateTimeProvider;
